export default __webpack_public_path__ + "static/media/BQ-SE.e2267027.svg";